// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2133": "22dc4571","2530": "e96a97f9","4878": "0639a139","6988": "de443d3a","8239": "bcb8d250","9601": "3e714e07",}[chunkId] + ".css"
}